import { render, staticRenderFns } from "./CustomerComplaintDetail.vue?vue&type=template&id=73db6268&scoped=true"
import script from "./CustomerComplaintDetail.vue?vue&type=script&lang=js"
export * from "./CustomerComplaintDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73db6268",
  null
  
)

export default component.exports